<template>
	<div  class="home">
		<div v-if="1==1"  
             class="col-md-offset-1 col-md-10">
			<div  v-if="$mq !== 'mobile'">
                <font size=+3 style="not-text-transform: uppercase; color:white;
                                     text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;">
					<b>
                    <span>Please take a look at what some of our customers have said...</span>
                    </b>
				</font>
                <br><br>
            </div>

			<div v-if="1==2"
                 class="panel panel-default drop-shadow">
				<div style="padding:5px; text-align:left;">
					<center>
						<div class="text-left" style='margin-left:auto; margin-right:auto; padding:10px;'>
                        	<div class="col-md-8 text-left"  style="padding:0px;">
                                <h3>I have to say that Filed Safely is simply genius!</h3>
                                It's my favourite thing at the moment. I’m always inventing - I create shows and have ideas the way some people 
                                write songs. The entire idea - beginning, middle and end - will come to me while doing the simplest things. 
                                <br><br>

                                It's the same when I'm writing songs. When I'm in the zone I need to know I can protect my work right there 
                                and then - at the drop of a hat.
                                <br><br>

                                The best part is knowing that <b>with Filed Safely I can make those ideas safe</b> straightaway by
                                emailing them in, and that’s it - it’s so simple!
                                <br><br>

                                <b><i>-- Sinitta</i></b>&nbsp;&nbsp;<a href=https://www.sinitta.com/>sinitta.com</a>
                                <br>&nbsp;
                            </div>
                        	<div class="col-md-4 text-right"  style="padding:0px;">
                                <img src="/images/sinitta-front-page2.png" width=250px>
                                <br><small>Image courtesy of Sinitta. &copy;2023 All Rights Reserved.</small>
                            </div>
						</div>
					</center>
                </div>
            </div>
            
			<div class="panel panel-default drop-shadow">
				<div style="padding:5px; text-align:left;">
					<center>
						<div class="text-left" style='margin-left:auto; margin-right:auto; padding:10px;'>
                        	<div class="col-md-8 text-left"  style="padding:0px;">
                                <h3>I’m loving using Filed Safely</h3>
                                I have finally found a way to protect my songs giving me peace of mind knowing that they're safe.
                                <br><br>
                                It’s also a great way to protect projects and any new ideas - so simple to use - great!
                                <br><br>

                                <b><i>-- Mauro Dirago</i></b>&nbsp;&nbsp;<a href=http://www.maurodirago.com/>maurodirago.com</a>
                                <br>&nbsp;
                            </div>
                        	<div class="col-md-4 text-right"  style="padding:0px;">
                                <img src="/images/mauro.png" width=250px>
                                <br><small>Image courtesy of Mauro Dirago. &copy;2023 All Rights Reserved.</small>
                            </div>
						</div>
					</center>
				</div>
			</div>

			<div class="panel panel-default drop-shadow">
				<div style="padding:5px; text-align:left;">
					<center>
						<div class="text-left" style='margin-left:auto; margin-right:auto; padding:10px;'>
                        	<div class="col-md-8 text-left"  style="padding:0px;">
                                <h3>I cannot recommend this service enough</h3>

                                I’ve been writing and producing music for over 25 years and the amount of money I’ve spent on 
                                registered post just to give my mind some sort of peace thinking my songs are protected must have 
                                run into the hundreds. 
                                <br><br>

                                In this day and age posting to myself won’t even stand up in court. Using Filed Safely has finally 
                                given me better protection for a fraction of the cost! What’s more I now know that the 
                                protection layer of block chain means it’s impossible for someone to say they wrote my song before me 
                                and if I send the file out and cc Filed Safely into the email the recipient will also receive an email 
                                saying my work has been registered... I cannot recommend this service enough!
                                <br><br>

                                <b><i>-- Martin West</i></b>&nbsp;&nbsp;Songwriter and Record Producer&nbsp;&nbsp;<a href=https://avenoir.org/>avenoir.org</a>
                                <br>&nbsp;
                            </div>
                        	<div class="col-md-4 text-right"  style="padding:0px;">
                                <img src="/images/martin.png" width=250px>
                                <br><small>Image courtesy of Martin West. &copy;2023 All Rights Reserved.</small>
                            </div>
						</div>
					</center>
				</div>
			</div>

            <br><br>
		</div>
	</div>
</template>


<script>

export default {
	name: 'terms',

	components: {
	},
	
	data() {
		return {
			env: process.env.VUE_APP_ENV,
		}
	},
	
	created() {
	},

	mounted() {
	},

	destroyed() {
	},

	methods: {
	},
}

</script>
